var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},_vm._l((_vm.GetBranches),function(branch,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"4"}},[_c('branch',{attrs:{"branch":branch}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }